export default "https://legacy.eskolare-development.com/images/notebook-smartphone.png";